import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const TypePropsSchema = z.object({
  typeValue: z.instanceof(HexNumber),
})

type TypeProps = z.infer<typeof TypePropsSchema>

export class Type extends ValueObject<TypeProps> {
  /**
   * @returns A type value
   */
  public getHexValue(): string {
    return this.props.typeValue.getValue()
  }

  public static create(typeValue: HexNumber): Type {
    const validatedProps = TypePropsSchema.parse({ typeValue })
    return new Type(validatedProps)
  }
}
